import styled from '@emotion/styled';
import { ICustomTheme } from 'interfaces';

export const StyledTitleWithUIGuidelines = styled.div<{
  theme: ICustomTheme;
  color?: string;
  isMobile?: boolean;
  margin?: string;
}>`
  margin: ${({ margin }) => margin || 'none'};
  color: ${({ color }) => color || 'black'};
  font-weight: 'bold';
  font-size: ${({ isMobile, theme }) =>
    `${
      isMobile ? theme.fontSizes.mobileTitle : theme.fontSizes.desktopTitle
    }px`};
`;
